<template>
  <vx-card>

    <vs-input
      ref="password"
      type="password"
      v-validate="'required|min:8|max:15'"
      name="password"
      label-placeholder="Contraseña"
      placeholder="Contraseña"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <vs-input
      type="password"
      v-validate="'min:8|max:15|confirmed:password'"
      data-vv-as="password"
      name="password_confirmation"
      label-placeholder="Confirmar Contraseña"
      placeholder="Confirmar Contraseña"
      v-model="password_confirmation"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-6" @click="submitChangePassword()" :disabled="!isFormValid">Cambiar Contraseña</vs-button>
      <vs-button class="ml-4 mt-6" type="border" color="warning" @click="reset()">Limpiar Campos</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data () {
    return {
      password: '',
      password_confirmation: ''
    }
  },
  computed: {
    isFormValid () {
      return !this.errors.any() && this.password !== '' && this.password_confirmation !== ''
    }
  },
  methods: {
    reset () {
      this.password = ''
      this.password_confirmation = ''
    },
    submitChangePassword () {
      const obj = {
        password: this.password,
        password_confirmation: this.password_confirmation
      }
      this.$vs.loading()
      this.$store.dispatch('updateUserPassword', obj)
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Contraseña cambiada',
            text: 'La contraseña ha sido actualizada exitosamente',
            color: 'success',
            iconPack: 'feather',
            icon:'icon-check',
            time: 4000
          })
        })
        .catch((error) => {
          this.$vs.loading.close()
          const mensaje_error = error.response.data.errors
          if (typeof mensaje_error === 'object') {
            const array_errors = Object.entries(mensaje_error)

            for (let i = 0; i < array_errors.length; i++) {
              this.$vs.notify({
                title: 'Username error',
                text: `${array_errors[i][1][0]}`,
                iconPack: 'feather',
                icon: 'icon-x-circle',
                color: 'warning',
                time: 6000
              })
            }
          } else {
            this.$vs.notify({
              title: 'Username error',
              text: `${mensaje_error}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        })
    }
  }
}
</script>
